module.exports = __webpack_public_path__ + "70cc3f8b12e9f2af0f88082957d7a824.svg";